import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: () => import('@/views/Home.vue'),
		meta: {}
	},
	{
		path: '/h5',
		name: 'H5',
		component: () => import('@/views/Home.vue'),
	},
	{
		path: '/ios',
		name: 'IOS',
		component: () => import('@/views/Ios.vue'),
	},
	{
		path: '/SlickCarouselDetail/:id',
		name: 'SlickCarouselDetail',
		component: () => import('@/views/SlickCarouselDetail.vue'),
		props: true,
		meta: {}
	}
]

const router = new VueRouter({
	mode: "hash",
	base: process.env.BASE_URL,
	routes
})

// 设备检测自动跳转
router.beforeEach((to, from, next) => {
	const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	// 在非iOS加载
	if (!isIOS || to.path === '/h5') {
		import('@/assets/google/fonts.css');
		import('@/assets/google/fontsico.css');
		import('@/static/css/google.css');
		import('@/static/css/googledatasafety.css');
		import('@/static/css/repeater_help_panel.css');
	} else {
		import('@/assets/fonts/fonts.css');
	}

	if (to.path === '/') {
		if (isIOS) {
			next('/ios')
		} else {
			next()
		}
	} else {
		next()
	}
})

export default router
